var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElIconTwitchBrand = function SvgElIconTwitchBrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6441a5",
    d: "M24.384.512H7.296C3.456.512.32 3.648.32 7.488v17.088c0 3.84 3.136 6.976 6.976 6.976h17.088c3.84 0 6.976-3.136 6.976-6.976V7.488A6.951 6.951 0 0 0 24.384.512zm-.192 17.856-4.608 4.544h-3.392l-1.728 2.304H12.16v-2.304H8.192V11.008l1.152-2.88h14.848v10.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6441a5",
    d: "m13.824 22.912 2.304-2.304h3.392l2.88-2.816v-8H10.432v10.816h3.392v2.304zm4.032-10.24h1.728v4.544h-1.728v-4.544zm-3.392 0h1.728v4.544h-1.728v-4.544z"
  })));
};
export default SvgElIconTwitchBrand;